<template>
  <div class="iDalgo-Select">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'iDalgo-Select'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
body, html {
  font-family: "source_sans_proregular", sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/layouts/iDalgo-Select.vue